import { render, staticRenderFns } from "./SendPaymentReminderModal.vue?vue&type=template&id=3d3ff687&scoped=true&lang=pug"
import script from "./SendPaymentReminderModal.vue?vue&type=script&lang=js"
export * from "./SendPaymentReminderModal.vue?vue&type=script&lang=js"
import style0 from "./SendPaymentReminderModal.vue?vue&type=style&index=0&id=3d3ff687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ff687",
  null
  
)

export default component.exports